export const SECURE_KEYS = ['ssn'];

export const ACTION_MAP = {
  create: 'created',
  update: 'updated',
  delete: 'deleted',
  upload: 'uploaded',
  cancel: 'canceled',
  reschedule: 'rescheduled',
  no_show: 'marked as no-show',
  restore: 'restored',
  pre_auth_sent: 'sent pre-auth to',
  payment_method_updated: 'updated',
  execute: 'executed actions',
  payer_rule_enacted: 'enacted a payer rule',
  payer_rule_dismissed: 'dismissed a payer rule'
};

export { HISTORY_ACTOR } from 'lib/constants/historyActor';
